import { render, staticRenderFns } from "./SkuListPagination.vue?vue&type=template&id=7c2950fa&scoped=true"
import script from "./SkuListPagination.vue?vue&type=script&lang=js"
export * from "./SkuListPagination.vue?vue&type=script&lang=js"
import style0 from "./SkuListPagination.vue?vue&type=style&index=0&id=7c2950fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2950fa",
  null
  
)

export default component.exports